var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// tslint:disable:no-null-keyword
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectBuildingHappiness, selectSelectedBuildingInfo, } from "../../../selectors/selectExistingBuildingInfo";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionBuildingsUnstoreBuilding } from "./actionBuildings";
import { BuildingInformation } from "./BuildingInformation";
import { BuildingStats } from "./BuildingStats";
import { ButtonPlaceBuilding } from "./ButtonPlaceBuilding";
var DetailViewInventoryDOM = /** @class */ (function (_super) {
    __extends(DetailViewInventoryDOM, _super);
    function DetailViewInventoryDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DetailViewInventoryDOM.prototype.render = function () {
        var _a = this.props, item = _a.item, happiness = _a.happiness, buildingInfo = _a.buildingInfo, onPlace = _a.onPlace, openInfoMenu = _a.openInfoMenu;
        var buildingInfoProps = {
            constructionTime: 0,
            happiness: happiness,
            item: item,
            workers: 0,
        };
        if (item) {
            return (React.createElement("div", { className: "flex flex--guts " + IdStyles.DetailViewWrapper },
                React.createElement("div", { className: "building-detail " + IdStyles.DetailView },
                    React.createElement(BuildingInformation, { item: item, onInfoButton: openInfoMenu },
                        React.createElement(BuildingStats, __assign({}, buildingInfoProps))),
                    React.createElement("div", { className: "building-detail__requirement " + IdStyles.BuildMenuRequirementSection },
                        React.createElement(ButtonPlaceBuilding, { buildingInfo: buildingInfo, onPlace: onPlace })))));
        }
        return null;
    };
    return DetailViewInventoryDOM;
}(React.PureComponent));
var mapState = function (state) {
    var level = 0;
    var buildingInfo = selectSelectedBuildingInfo(state);
    var buildingTypeId = buildingInfo.balancing.id;
    return {
        buildingInfo: buildingInfo,
        happiness: selectBuildingHappiness(state, buildingTypeId, level),
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onPlace: actionBuildingsUnstoreBuilding,
        openInfoMenu: function () { return actionModalOpen(IdModal.BuildingInfo); },
    }, dispatch);
};
export var DetailViewInventory = connect(mapState, mapDispatch)(DetailViewInventoryDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/DetailViewInventory.tsx
// module id = 2739
// module chunks = 3